import React, { Component } from "react";
import DonutPMDecisionsCurrentMarketingSpend from "./charts/DonutPMDecisionsCurrentMarketingSpend";
import AbbreviateNumber from "../../ui-building-blocks/numbers/AbbreviateNumber";
import Styled from "components/pm/style";
import { view } from "@risingstack/react-easy-state";

class PMDecisionsCurrentMarketingSpend extends Component {
  get sumOfTraditionalMarketingSpend() {
    return this.calculateSum(
      this.props.promos,
      this.props.marketing_clients["Traditional Marketing"],
      "spend"
    );
  }

  get sumOfDigitalMarketingSpend() {
    return this.calculateSum(
      this.props.promos,
      this.props.marketing_clients["Digital Marketing"],
      "spend"
    );
  }

  get sumOfDirectSalesSpend() {
    return this.calculateSum(
      this.props.sales,
      this.props.sales_clients["Direct Sales"],
      "total"
    );
  }

  get sumOfDistributorsSpend() {
    return this.calculateSum(
      this.props.sales,
      this.props.sales_clients["Distributors"],
      "total"
    );
  }

  get sumOfMarketingSpend() {
    return - this.sumOfTraditionalMarketingSpend - this.sumOfDigitalMarketingSpend - this.sumOfDirectSalesSpend - this.sumOfDistributorsSpend;
  }

  get sumOfCashReceiptsPriorRoundSales() {
    const { accountsReceivable } = this.props;

    return accountsReceivable;
  }

  get totalMarketingSpend() {
    return this.sumOfMarketingSpend;
  }

  calculateSum(data, type, key) {
    let sum = 0;
    let l = data.length;

    for (let i = 0; i < l; i += 1) {
      if (data[i].player !== null && data[i].client === type) {
        sum += data[i][key];
      }
    }

    return sum;
  }

  render() {
    const { isMobile } = this.props;

    return (
      <Styled.WhiteBlockColumn width="calc(100% - 457px)">
        <Styled.CMS.Title>Current Marketing Spend</Styled.CMS.Title>
        <Styled.CMS.Amount>
          <AbbreviateNumber value={this.totalMarketingSpend} />
        </Styled.CMS.Amount>
        <DonutPMDecisionsCurrentMarketingSpend
          sumOfTraditionalMarketingSpend={this.sumOfTraditionalMarketingSpend}
          sumOfDigitalMarketingSpend={this.sumOfDigitalMarketingSpend}
          sumOfDirectSalesSpend={this.sumOfDirectSalesSpend}
          sumOfDistributorsSpend={this.sumOfDistributorsSpend}
          sumOfMarketingSpend={this.sumOfMarketingSpend}
          isMobile={isMobile}
        />
      </Styled.WhiteBlockColumn>
    );
  }
}

export default view(PMDecisionsCurrentMarketingSpend);



// WEBPACK FOOTER //
// ./src/components/pm/decisions/PMDecisionsCurrentMarketingSpend.js